export default {
  title: {
    en: 'The premium product has a ${price} surcharge',
  },
  text: {
    en: `
      You also have a Scentbird gift subscription, which means your account will
      only reflect the Premium Product surcharge \${price}.
    `,
  },
  buttonTitle: {
    en: 'Add payment method to order the premium product',
  },
}
